import React, { useState, useRef, useEffect } from "react";
import { RiArrowRightSLine } from "react-icons/ri";
import { RiArrowLeftSLine } from "react-icons/ri";
import { MdDashboardCustomize } from "react-icons/md";
import { RiAddLargeFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import {
  setWorkbookProperty,
  deleteTemporaryFilters,
  updateL1Property,
  RemoveSheet,
  CreateSheet,
  getL1SheetProperty,
} from "./WorkbookSlice";

import { useDeleteSheetMutation } from "./dataApiSlice";
import SheetVisibilityModal from "./components/WorkbookPopups/SheetVisibilityModal";
import {
  deleteSheetControls,
  getSheetControls,
  setSheetControls,
} from "./WorkbookControllingSlice";

const Footer = ({ SheetNameBtm, selectedSheetIndex, selectedSheetId }) => {
  const [editingIndex, setEditingIndex] = useState(null);
  console.log(editingIndex);
  const [sheetNames, setSheetNames] = useState(
    SheetNameBtm.map((sheet) => sheet.SheetName)
  );
  const [hiddenSheets, setHiddenSheets] = useState(
    SheetNameBtm.filter((sheet) => !sheet.isSheetVisible)
  ); // Manage hidden sheets

  const [sheetId, setSheetId] = useState(null);
  const [contextMenu, setContextMenu] = useState(null);
  const [sheetVisibilityModal, setSheetVisibilityModal] = useState(false);
  console.log(contextMenu);
  useEffect(() => {
    console.log(editingIndex);
    if (editingIndex) {
      console.log(editingIndex);
      setContextMenu(null);
    }
  }, [editingIndex]);
  const dialogRef = useRef(null);
  const dispatch = useDispatch();

  const createSheet = () => {
    dispatch(
      CreateSheet({
        Action: "CreateSheet",
        isDataSourceChanging: false,
      })
    );
  };

  const [deleteSheet, { data, isError, error, isLoading, isSuccess }] =
    useDeleteSheetMutation();

  const createDuplicateSheet = (index) => {
    const findSheetIdForDuplicating = SheetNameBtm.find(
      (Sheet) => Sheet.index === index
    );
    dispatch(
      CreateSheet({
        Action: "Duplicate",
        ID: findSheetIdForDuplicating.ID,
      })
    );
  };

  const createDashboard = () => {
    console.log("hi");
    dispatch(
      CreateSheet({
        Action: "createDashboard",
      })
    );
  };
  const handleDoubleClick = (index) => {
    setEditingIndex(index);
    setSheetId(SheetNameBtm[index].ID);
  };
  const handleNameChange = (e, index) => {
    const newSheetNames = [...sheetNames];
    newSheetNames[index] = e.target.value;
    setSheetNames(newSheetNames);
  };

  const handleBlur = () => {
    if (editingIndex !== null) {
      dispatch(
        updateL1Property({
          SheetId: sheetId,
          key: "SheetName",
          value: sheetNames[editingIndex],
        })
      );
    }
    setEditingIndex(null);
    setContextMenu(null);
  };

  const handleContextMenu = (event, index) => {
    event.preventDefault();
    const buttonRect = event.target.getBoundingClientRect();
    setContextMenu({
      index,
      xPos: buttonRect.left + window.scrollX + 85,
      yPos: buttonRect.top + window.scrollY - 10,
    });
    setSheetId(SheetNameBtm[index].ID);
  };
  const closeDialog = () => {
    setContextMenu(null);
  };
  const handleClickOutside = (event) => {
    if (dialogRef.current && !dialogRef.current.contains(event.target)) {
      closeDialog();
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Enter") {
      handleBlur();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // New useEffect to sync sheetNames with SheetNameBtm
  useEffect(() => {
    setSheetNames(SheetNameBtm.map((sheet) => sheet.SheetName));
  }, [SheetNameBtm]);

  const scrollLeft = () => {
    document.getElementById("scrollableDiv").scrollBy({
      left: -100, // Adjust the number for the scroll distance
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    document.getElementById("scrollableDiv").scrollBy({
      left: 100, // Adjust the number for the scroll distance
      behavior: "smooth",
    });
  };
  const removeSheet = ({ sheetId, index }) => {
    console.log(sheetId);

    if (sheetId !== null) {
      dispatch(RemoveSheet({ sheetId }));
      deleteSheet({ sheetId: sheetId });
      closeDialog();
    }
  };
  console.log(sheetId);

  // hide isSheetVisibleNot

  const hideSheet = ({ sheetId, index }) => {
    if (sheetId !== null) {
      // Update visibility in the Redux store
      dispatch(
        updateL1Property({
          SheetId: sheetId,
          key: "isSheetVisible",
          value: false,
        })
      );

      // Update local state to immediately hide the sheet
      setSheetNames((prevNames) => {
        const updatedNames = [...prevNames];
        updatedNames[index] = ""; // Remove the sheet name to hide it
        return updatedNames;
      });

      closeDialog();
    }
  };
  const handleSheetVisibilityModal = () => {
    setSheetVisibilityModal(!sheetVisibilityModal);
  };
  console.log(sheetId);
  const currentSheetQuery = useSelector((state) =>
    getL1SheetProperty(state, sheetId, "query")
  );
  console.log(currentSheetQuery);
  const sheetControls = useSelector((state) =>
    getSheetControls({
      Sheetid: sheetId,
      keys: [
        "isPause",
        "isAnimataionOff",
        "uniqueColumnValues",
        "rowsHeirarchyItem",
        "groupHeirarchyItem",
      ],
    })(state)
  );
  const { isPause, isAnimataionOff, uniqueColumnValues } =
    sheetControls !== undefined && sheetControls;

  const handleSheetChange = (sheetId) => {
    if (sheetId) {
      setSheetId(sheetId);
      dispatch(
        setSheetControls({
          Sheetid: sheetId,
          controls: {
            isPause: isPause,
            isAnimataionOff: isAnimataionOff,
            uniqueColumnValues: uniqueColumnValues,
            sheetQuery: currentSheetQuery,
          },
        })
      );
      dispatch(
        deleteTemporaryFilters({
          sourceSheet: null,
          allTempFiltersBoolean: true,
        })
      );
      dispatch(deleteSheetControls());
      dispatch(
        setWorkbookProperty({
          itemInArray: false,
          key: "selectedSheetId",
          value: sheetId,
        })
      );
    } else {
      console.log("sheetId not found");
    }
  };

  const unhideSheet = (sheetId, index) => {
    if (index === 2) return; // Prevent action for the first index
    if (sheetId !== null) {
      // Update visibility in Redux store
      dispatch(
        updateL1Property({
          SheetId: sheetId,
          key: "isSheetVisible",
          value: true,
        })
      );
      // Remove from hidden sheets
      setHiddenSheets(hiddenSheets.filter((sheet) => sheet.ID !== sheetId));
    }
  };

  const [buttonText, setButtonText] = useState("long text here");
  const maxLength = 11 * 16; // 11rem converted to pixels (assuming 16px font size)
  return (
    <>
      <footer className="font-light flex items-center justify-between rounded shadow-md border border-gray-200 w-full h-[2%] min-h-[30px] px-1">
        <section className="flex items-center justify-center w-full">
          <button
            className="pl-[5px] pr-[2.5px] py-[1.5px] mr-[1px] bg-transparent  text-blue-950 border-gray-200 border flex items-center justify-center rounded"
            onClick={scrollLeft}
          >
            <RiArrowLeftSLine className="text-lg h-[4.5] w-4" />
          </button>

          <div className="flex justify-start items-center w-full h-full overflow-x-auto overflow-hidden gap-[3px] ml-[2px]">
            <div
              id="scrollableDiv"
              className="flex items-center gap-[2px]"
              style={{ overflowX: "hidden", whiteSpace: "nowrap" }}
            >
              {SheetNameBtm.map((sheet, index) => {
                // Render the rest of the sheets based on visibility
                return (
                  sheet.isSheetVisible !== false &&
                  (editingIndex === index ? (
                    <input
                      key={sheet.ID}
                      className="px-1 text-[#374151] w-56 h-full truncate text-center border-[#e5e7eb] rounded text-sm"
                      value={sheetNames[index]}
                      onChange={(e) => handleNameChange(e, index)}
                      onKeyDown={(e) => e.key === "Enter" && handleBlur()}
                      onBlur={handleBlur}
                      autoFocus
                    />
                  ) : (
                    <button
                      key={sheet.ID}
                      className={`${
                        selectedSheetId === sheet.ID
                          ? "bg-gray-200 text-black border-gray-400"
                          : "bg-white text-gray-950"
                      } font-[350] text-sm text-center border justify-center px-[5px] truncate rounded`}
                      style={{
                        minWidth: "5rem",
                        maxWidth: "11rem",
                        width: "auto",
                      }}
                      onClick={() => handleSheetChange(sheet.ID)}
                      onDoubleClick={() => handleDoubleClick(index)}
                      onContextMenu={(event) => handleContextMenu(event, index)}
                    >
                      {sheetNames[index]}
                    </button>
                  ))
                );
              })}
            </div>
          </div>

          <button
            className="pl-[5.5px] pr-[2.5px] py-[1.5px] mr-[2px] bg-transparent  text-blue-950 border-gray-200 border flex items-center justify-center rounded"
            onClick={scrollRight}
          >
            <RiArrowRightSLine className="text-lg h-[4] w-4" />
          </button>
          <button
            className="px-[7px] py-[2.5px] mr-[2px] bg-transparent  text-blue-950 border-gray-200 border flex items-center justify-center rounded"
            onClick={createSheet}
          >
            <RiAddLargeFill className="" />
          </button>

          <button
            className="pl-[5.5px] pr-[2.5px] py-[1.5px]  bg-transparent text-blue-950 border-gray-200 border flex items-center justify-center rounded"
            onClick={() => createDashboard()}
          >
            <MdDashboardCustomize className="text-lg h-[4.5] w-4" />
          </button>
        </section>
        {contextMenu && (
          <section
            ref={dialogRef}
            className="font-light text-sm flex flex-col items-start justify-start absolute bg-white text-[#374151] border border-[#e5e7eb] shadow-lg p-2 rounded pl-2"
            style={{
              top: contextMenu.yPos + "px",
              left: contextMenu.xPos + "px",
              transform: "translateY(-100%)",
              // paddingRight: "1rem",
            }}
          >
            <button
              className="mb-1"
              onClick={() => {
                setEditingIndex(contextMenu.index);
                setContextMenu(null);
              }}
            >
              Rename
            </button>
            <button
              className="mb-1"
              onClick={() => {
                createDuplicateSheet(contextMenu.index);
                setContextMenu(null);
              }}
            >
              Duplicate
            </button>
            <button
              onClick={() => {
                removeSheet({ sheetId, index: contextMenu.index });
                setContextMenu(null);
              }}
            >
              {SheetNameBtm.length === 1 ? null : "Delete"}
            </button>
            <button
              className="mb-1 "
              onClick={() => {
                hideSheet({ sheetId, index: contextMenu.index });
                setContextMenu(null);
              }}
            >
              {SheetNameBtm.length === 1 ? null : "Hide"}
            </button>
            <button className="mb-1" onClick={handleSheetVisibilityModal}>
              Unhide
            </button>
          </section>
        )}
      </footer>
      {sheetVisibilityModal ? (
        <SheetVisibilityModal
          handleSheetVisibilityModal={handleSheetVisibilityModal}
          sheetNameBtm={SheetNameBtm}
          sheetId={sheetId}
          unhideSheet={unhideSheet}
        />
      ) : null}
    </>
  );
};
export default Footer;
